module.exports = __webpack_public_path__ + "img/header-logo.4ecf9ba5.svg";